import { createEntityQuery } from '../../createEntityQuery';
import {
  ParticipantService,
  UserDefinedFieldValuesService,
  type Wealthlane_CustomerService_Dtos_Participant_ViewParticipantDto,
  type Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_UserDefinedFieldValuesDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

export type ParticipantViewResult = Wealthlane_CustomerService_Dtos_Participant_ViewParticipantDto & {
  udfValues?: Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_UserDefinedFieldValuesDto[];
  participantId?: string;
};

interface ParticipantViewParams {
  participantId: string;
  udfModuleId?: number;
}

/**
 * Fetches participant view data with UDF values combined.
 * Composition hook — orchestrates ParticipantService + UserDefinedFieldValuesService.
 */
export const useGetParticipantView = createEntityQuery<ParticipantViewResult, ParticipantViewParams>({
  queryKey: ['participantView'],
  queryFn: async (params) => {
    const { participantId, udfModuleId = 1 } = params!;
    const [participant, udfValues] = await Promise.all([
      ParticipantService.getApiCustomerApiAppParticipantParticipantById(participantId),
      UserDefinedFieldValuesService.getApiCustomerApiAppUserDefinedFieldValuesUserDefinedFieldValues(
        udfModuleId,
        participantId,
      ),
    ]);
    return { ...participant, udfValues, participantId };
  },
});
